// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-info {
  max-width: 70%;
  vertical-align: top;
  display: block;
}
.user-info .user-fullname {
  font-size: 16px;
  color: black;
}
.user-info.ellipsis > div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* These are technically the same, but use both */
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  /* This is the dangerous one in WebKit, as it breaks things wherever */
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;
  display: block;
}

.user-title, .user-org {
  color: #909092;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-gb, .user-moderator {
  color: #f2b130;
  font-size: 12px;
}

.attendees {
  margin-top: 1em;
}
.attendees hr {
  margin-top: 0;
  margin-bottom: 0;
}
.attendees .user-list {
  padding: 5px;
  display: block;
  position: relative;
}
.attendees .user-list .user-icons {
  margin: 0.5em;
  position: absolute;
  top: 0;
  right: 0;
  color: #606060;
}
.attendees .user-list .user-icons ul li {
  list-style-type: none;
}

.biz-card-div {
  cursor: pointer;
  margin-top: 2px;
  padding: 5px;
  text-align: center;
  background-color: #4330ff;
  border: 1px solid #4330ff;
  color: white;
  width: 100%;
}

.biz-card-link:hover {
  color: white;
  cursor: pointer;
}
.biz-card-link:hover:hover {
  text-decoration: none;
  color: white;
}

.user-filter-div {
  margin-top: 0px;
  background-color: #002869;
}

/*user-list*/
.user-list-link {
  color: black;
}

.user-list-link:hover {
  color: black;
  background: #f2f2f2;
}

.user-list.hover:hover {
  background: #f2f2f2;
}

.nohover {
  cursor: default;
}

.user-list .user-info {
  display: inline-block;
  width: 85%;
  padding: 5px 0 0 10px;
}

/*user-page*/
.user-profile .user-list-link:hover {
  background: none;
}
.user-profile .user-list:hover {
  background: none;
}
.user-profile .user-list {
  margin-top: 1em;
}
.user-profile .user-list .user-icons {
  margin: 0.5em;
  float: right;
}
.user-profile .user-list .user-icons ul li {
  list-style-type: none;
}
.user-profile .user-list:hover {
  cursor: default;
}
.user-profile .blue-header {
  color: #4330ff;
}
.user-profile .user-actions .disabled-send {
  color: #909092;
}
.user-profile .user-actions {
  padding: 1em 0 1em 0;
}
.user-profile .user-actions button {
  width: 100%;
  border-radius: 5px;
  background-color: #f2f2f2;
  border: 1px solid #c0c0c0;
  color: #4330ff;
  margin-bottom: 0.5em;
}
.user-profile .user-actions .active-button {
  background-color: #4330ff;
  color: white;
}
.user-profile .user-bio .no-bio {
  color: #909092;
}
.user-profile .red a button {
  color: #ff2e2e;
}

.fa-stack {
  width: 100%;
  height: 100%;
  line-height: 1.5;
  font-size: 1rem;
}

.fa-stack[data-count]:after {
  position: absolute;
  right: -1%;
  top: 1%;
  content: attr(data-count);
  font-size: 30%;
  padding: 0.6em;
  border-radius: 999px;
  line-height: 0.75em;
  color: white;
  background: rgba(255, 0, 0, 0.85);
  text-align: center;
  min-width: 2em;
  font-weight: bold;
}

/*my-profile*/
.my-biz-card {
  background: #dcdcdc;
  border: 0.15em solid #000;
  border-radius: 0.75em;
  padding: 0.75em;
}

.form-fine-print {
  color: #909092;
}

.display-date {
  background: gray;
  color: #fff;
  padding: 0.2em 0.45em;
}

.session-link {
  width: calc(100% - 100px);
}
.session-link:hover {
  text-decoration: none;
}

.session-icons {
  margin: 0.5em;
  position: absolute;
  right: 0;
  top: 0;
  color: #606060;
}
.session-icons ul li {
  list-style-type: none;
}

.user-profile .button-disabled {
  color: gray !important;
}
.user-profile .session {
  color: black;
  border: 0.5px solid #eaeaea;
  line-height: 10px;
  text-decoration: none;
  position: relative;
}
.user-profile .session:hover {
  background: #d4e4e9;
}
.user-profile .session-time {
  background: #909092;
  color: white;
  padding: 10px;
}
.user-profile .session-reg {
  text-align: center;
  width: 90px;
}
.user-profile .session-reg .fa {
  margin-top: 0.1em;
  font-size: 2.25em;
}
.user-profile .session-reg .fa.fa-plus-circle {
  color: gray;
}
.user-profile .session-reg .fa.fa-check-circle {
  color: #4330ff;
}
.user-profile .session-reg .fa.fa-check-circle.yellow {
  color: #feb52b;
}
.user-profile .session-name {
  padding-top: 10px;
  color: black;
  line-height: 1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* These are technically the same, but use both */
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  /* This is the dangerous one in WebKit, as it breaks things wherever */
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;
  display: block;
}
.user-profile .session-room {
  padding-top: 0px;
  color: #909092;
  font-size: 12px;
}
.user-profile .track-color {
  display: inline;
  padding: 1px;
  float: left;
  width: 0.25em;
  min-height: 4.5em;
  margin-right: 0.35em;
}
.user-profile .session-reg {
  border: 0.5px solid #eaeaea;
  background: #f2f2f2;
  padding-right: 0px !important;
}
.user-profile .session-reg p {
  margin: 5px 0 5px -5px;
  text-align: center;
}

.blue {
  color: #4330ff;
}

.session-name {
  padding-top: 10px;
  color: black;
}

.session-room {
  padding-top: 0px;
  color: #909092;
  font-size: 12px;
}

.session.itinerary {
  padding: 20px;
}
.session.itinerary .session-name {
  color: #909092;
}

@media only screen and (max-width: 760px) {
  .session-reg {
    width: 60px;
    font-size: 12px;
  }
}
.my-profile-photo {
  margin-top: 30px;
  text-align: center;
}
.my-profile-photo button {
  border-radius: 5px;
  background-color: #f2f2f2;
  border: 1px solid #c0c0c0;
  color: #4330ff;
  margin-bottom: 3px;
  margin-left: 5px;
}
.my-profile-photo input[type=file] {
  display: none;
}
.my-profile-photo .custom-file-upload {
  border-radius: 5px;
  background-color: #f2f2f2;
  border: 1px solid #c0c0c0;
  color: #4330ff;
  display: inline-block;
  padding: 6px 12px;
  margin-left: 5px;
  cursor: pointer;
}
.my-profile-photo .rounded-circle {
  max-width: 250px;
}

.business-card-info {
  background-color: #f2f2f2;
  border: 1px solid #404040;
  color: #404040;
  border-radius: 5px;
  padding: 10px;
}
.business-card-info .name {
  font-size: 1.5em;
  font-weight: bold;
}

`, "",{"version":3,"sources":["webpack://./src/components/Users/users.scss","webpack://./src/components/Users/users.css","webpack://./src/app/variables.scss"],"names":[],"mappings":"AACA;EACE,cAAA;EACA,mBAAA;EACA,cAAA;ACAF;ADCE;EACE,eEiCI;EFhCJ,YAAA;ACCJ;ADCE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EAEF,iDAAA;EACE,yBAAA;EACA,qBAAA;EAEA,yBAAA;EACA,sEAAA;EACA,qBAAA;EACA,uCAAA;EACA,sBAAA;EACA,cAAA;ACDJ;;ADKA;EACE,cEhBkB;EFiBlB,eEaQ;EFZR,gBAAA;EACA,uBAAA;EACA,mBAAA;ACFF;;ADKA;EACE,cElBK;EFmBL,eEKQ;ADPV;;ADKA;EACE,eAAA;ACFF;ADGE;EACE,aAAA;EACA,gBAAA;ACDJ;ADGE;EACE,YAAA;EACA,cAAA;EACA,kBAAA;ACDJ;ADEI;EACE,aAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,cEzCa;ADyCnB;ADCM;EACE,qBAAA;ACCR;;ADKA;EACE,eAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBE1CY;EF2CZ,yBAAA;EACA,YAAA;EACA,WAAA;ACFF;;ADIA;EACI,YAAA;EACA,eAAA;ACDJ;ADEI;EACE,qBAAA;EACA,YAAA;ACAN;;ADGA;EACE,eAAA;EACA,yBEvDa;ADuDf;;ADGA,YAAA;AACA;EACE,YAAA;ACAF;;ADGA;EACE,YAAA;EACA,mBEpFc;ADoFhB;;ADGA;EACE,mBExFc;ADwFhB;;ADGA;EACE,eAAA;ACAF;;ADGA;EACE,qBAAA;EACA,UAAA;EACA,qBAAA;ACAF;;ADGA,YAAA;AAEE;EACE,gBAAA;ACDJ;ADIE;EACE,gBAAA;ACFJ;ADIE;EACE,eAAA;ACFJ;ADGI;EACE,aAAA;EACA,YAAA;ACDN;ADEM;EACE,qBAAA;ACAR;ADGI;EACE,eAAA;ACDN;ADIE;EACE,cE3GU;ADyGd;ADKI;EACE,cE7Hc;AD0HpB;ADCE;EAIE,oBAAA;ACFJ;ADGI;EACE,WAAA;EACA,kBAAA;EACA,yBEtIU;EFuIV,yBAAA;EACA,cEvHQ;EFwHR,oBAAA;ACDN;ADGI;EACE,yBE3HQ;EF4HR,YAAA;ACDN;ADKI;EACE,cE/Ic;AD4IpB;ADME;EACE,cE5JU;ADwJd;;ADQA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;ACLF;;ADQA;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,yBAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;ACLF;;ADQA,aAAA;AACA;EACE,mBEjLqB;EFkLrB,yBAAA;EACA,qBAAA;EACA,eAAA;ACLF;;ADQA;EACE,cEvLkB;ADkLpB;;ADQA;EACE,gBAAA;EACA,WAAA;EACA,qBAAA;ACLF;;ADQA;EACE,yBAAA;ACLF;ADME;EACE,qBAAA;ACJJ;;ADOA;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,cEzMiB;ADqMnB;ADKE;EACE,qBAAA;ACHJ;;ADQE;EACE,sBAAA;ACLJ;ADOE;EACE,YAAA;EACA,2BAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;ACLJ;ADOE;EACE,mBElOc;AD6NlB;ADOE;EACE,mBEhOgB;EFiOhB,YAAA;EACA,aAAA;ACLJ;ADQE;EACE,kBAAA;EACA,WAAA;ACNJ;ADOI;EACE,iBAAA;EACA,iBAAA;ACLN;ADMM;EACE,WAAA;ACJR;ADMM;EACE,cEjOM;AD6Nd;ADKQ;EACE,cE3PM;ADwPhB;ADSE;EACE,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iDAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sEAAA;EACA,qBAAA;EACA,uCAAA;EACA,sBAAA;EACA,cAAA;ACPJ;ADSE;EACE,gBAAA;EACA,cE1QgB;EF2QhB,eE7OM;ADsOV;ADUE;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;ACRJ;ADUE;EACE,2BAAA;EACA,mBE3RY;EF4RZ,6BAAA;ACRJ;ADSI;EACE,sBAAA;EACA,kBAAA;ACPN;;ADYA;EACE,cEpRY;AD2Qd;;ADWA;EACE,iBAAA;EACA,YAAA;ACRF;;ADUA;EACE,gBAAA;EACA,cE1SkB;EF2SlB,eE7QQ;ADsQV;;ADSA;EACE,aAAA;ACNF;ADOE;EACE,cEhTgB;AD2SpB;;ADSA;EACE;IACE,WAAA;IACA,eAAA;ECNF;AACF;ADSA;EACE,gBAAA;EACA,kBAAA;ACPF;ADQE;EACE,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,cEpTU;EFqTV,kBAAA;EACA,gBAAA;ACNJ;ADQE;EACI,aAAA;ACNN;ADQE;EACE,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,cE/TU;EFgUV,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;ACNJ;ADQE;EACE,gBAAA;ACNJ;;ADUA;EACE,yBE5Vc;EF6Vd,yBAAA;EACA,cExVU;EFyVV,kBAAA;EACA,aAAA;ACPF;ADQE;EACE,gBAAA;EACA,iBAAA;ACNJ","sourcesContent":["@import '../../app/variables.scss';\n.user-info {\n  max-width: 70%;\n  vertical-align: top;\n  display: block;\n  .user-fullname {\n    font-size: $large;\n    color: black;\n  }\n  &.ellipsis > div{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n  /* These are technically the same, but use both */\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n\n    -ms-word-break: break-all;\n    /* This is the dangerous one in WebKit, as it breaks things wherever */\n    word-break: break-all;\n    /* Instead use this non-standard one: */\n    word-break: break-word;\n    display:block;\n  }\n}\n\n.user-title, .user-org {\n  color: $medium-light-gray;\n  font-size: $smaller;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-gb, .user-moderator {\n  color: $gold;\n  font-size: $smaller;\n}\n\n.attendees {\n  margin-top: 1em;\n  hr {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .user-list {\n    padding: 5px;\n    display: block;\n    position: relative;\n    .user-icons {\n      margin: .5em;\n      position: absolute;\n      top: 0;\n      right: 0;\n      color: $medium-dark-gray;\n      ul li {\n        list-style-type: none;\n      }\n    }\n  }\n}\n\n.biz-card-div {\n  cursor: pointer;\n  margin-top: 2px;\n  padding: 5px;\n  text-align: center;\n  background-color: $evanta-blue;\n  border: 1px solid $evanta-blue;\n  color: white;\n  width: 100%;\n}\n.biz-card-link:hover{\n    color: white;\n    cursor: pointer;\n    &:hover {\n      text-decoration: none;\n      color: white;\n    }\n}\n.user-filter-div{\n  margin-top: 0px;\n  background-color: $gartner-blue;\n}\n\n/*user-list*/\n.user-list-link {\n  color: black;\n}\n\n.user-list-link:hover {\n  color: black;\n  background: $lightest-gray;\n}\n\n.user-list.hover:hover {\n  background: $lightest-gray;\n}\n\n.nohover {\n  cursor: default;\n}\n\n.user-list .user-info {\n  display: inline-block;\n  width: 85%;\n  padding: 5px 0 0 10px;\n}\n\n/*user-page*/\n.user-profile {\n  .user-list-link:hover {\n    background: none;\n  }\n\n  .user-list:hover {\n    background: none;\n  }\n  .user-list {\n    margin-top: 1em;\n    .user-icons {\n      margin: .5em;\n      float: right;\n      ul li {\n        list-style-type: none;\n      }\n    }\n    &:hover{\n      cursor: default;\n    }\n  }\n  .blue-header {\n    color: $evanta-blue;\n  }\n  .user-actions {\n    .disabled-send {\n      color: $medium-light-gray;\n    }\n    padding: 1em 0 1em 0;\n    button {\n      width: 100%;\n      border-radius: 5px;\n      background-color: $lightest-gray;\n      border: 1px solid $medium-gray;\n      color: $evanta-blue;\n      margin-bottom: 0.5em;\n    }\n    .active-button {\n      background-color: $evanta-blue;\n      color: white;\n    }\n  }\n  .user-bio {\n    .no-bio {\n      color: $medium-light-gray;\n    }\n  }\n  .red a button {\n    color: $error-color;\n  }\n}\n\n.fa-stack {\n  width: 100%;\n  height: 100%;\n  line-height: 1.5;\n  font-size: 1rem;\n}\n\n.fa-stack[data-count]:after{\n  position:absolute;\n  right:-1%;\n  top:1%;\n  content: attr(data-count);\n  font-size:30%;\n  padding:.6em;\n  border-radius:999px;\n  line-height:.75em;\n  color: white;\n  background:rgba(255,0,0,.85);\n  text-align:center;\n  min-width:2em;\n  font-weight:bold;\n}\n\n/*my-profile*/\n.my-biz-card {\n  background: $medium-lightest-gray;\n  border: .15em solid #000;\n  border-radius: .75em;\n  padding: .75em;\n}\n\n.form-fine-print {\n  color: $medium-light-gray;\n}\n\n.display-date {\n  background: gray;\n  color: #fff;\n  padding: .2em .45em;\n}\n\n.session-link {\n  width: calc(100% - 100px);\n  &:hover{\n    text-decoration: none;\n  }\n}\n.session-icons {\n  margin: .5em;\n  position: absolute;\n  right: 0;\n  top: 0;\n  color: $medium-dark-gray;\n  ul li {\n    list-style-type: none;\n  }\n}\n\n.user-profile {\n  .button-disabled {\n    color: gray !important;\n  }\n  .session {\n    color: black;\n    border: 0.5px solid $light-gray;\n    line-height: 10px;\n    text-decoration: none;\n    position: relative;\n  }\n  .session:hover {\n    background: $blue-light-gray;\n  }\n  .session-time{\n    background: $medium-light-gray;\n    color: white;\n    padding: 10px;\n  }\n\n  .session-reg {\n    text-align: center;\n    width: 90px;\n    .fa {\n      margin-top: .1em;\n      font-size: 2.25em;\n      &.fa-plus-circle {\n        color: gray;\n      }\n      &.fa-check-circle {\n        color: $evanta-blue;\n        &.yellow {\n          color: $warning-color;\n        }\n      }\n    }\n  }\n\n  .session-name {\n    padding-top: 10px;\n    color: black;\n    line-height: 1em;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    /* These are technically the same, but use both */\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    -ms-word-break: break-all;\n    /* This is the dangerous one in WebKit, as it breaks things wherever */\n    word-break: break-all;\n    /* Instead use this non-standard one: */\n    word-break: break-word;\n    display: block;\n  }\n  .session-room {\n    padding-top: 0px;\n    color: $medium-light-gray;\n    font-size: $smaller;\n  }\n\n  .track-color {\n    display: inline;\n    padding: 1px;\n    float: left;\n    width: .25em;\n    min-height: 4.5em;\n    margin-right: .35em;\n  }\n  .session-reg {\n    border: 0.5px solid $light-gray;\n    background: $lightest-gray;\n    padding-right: 0px !important;\n    p {\n      margin: 5px 0 5px -5px;\n      text-align: center;\n    }\n  }\n}\n\n.blue {\n  color: $evanta-blue;\n}\n.session-name {\n  padding-top: 10px;\n  color: black;\n}\n.session-room {\n  padding-top: 0px;\n  color: $medium-light-gray;\n  font-size: $smaller;\n}\n.session.itinerary {\n  padding: 20px;\n  .session-name {\n    color: $medium-light-gray;\n  }\n}\n\n@media only screen and (max-width : 760px){\n  .session-reg {\n    width: 60px;\n    font-size: 12px;\n  }\n}\n\n.my-profile-photo {\n  margin-top: 30px;\n  text-align: center;\n  button {\n    border-radius: 5px;\n    background-color: #f2f2f2;\n    border: 1px solid #c0c0c0;\n    color: $evanta-blue;\n    margin-bottom: 3px;\n    margin-left: 5px;\n  }\n  input[type=\"file\"] {\n      display: none;\n  }\n  .custom-file-upload {\n    border-radius: 5px;\n    background-color: #f2f2f2;\n    border: 1px solid #c0c0c0;\n    color: $evanta-blue;\n    display: inline-block;\n    padding: 6px 12px;\n    margin-left: 5px;\n    cursor: pointer;\n  }\n  .rounded-circle {\n    max-width: 250px;\n  }\n}\n\n.business-card-info {\n  background-color: $lightest-gray; // eggshell white\n  border: 1px solid $dark-gray;\n  color: $dark-gray;\n  border-radius: 5px;\n  padding: 10px;\n  .name {\n    font-size: 1.5em;\n    font-weight: bold;\n  }\n}\n",".user-info {\n  max-width: 70%;\n  vertical-align: top;\n  display: block;\n}\n.user-info .user-fullname {\n  font-size: 16px;\n  color: black;\n}\n.user-info.ellipsis > div {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* These are technically the same, but use both */\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -ms-word-break: break-all;\n  /* This is the dangerous one in WebKit, as it breaks things wherever */\n  word-break: break-all;\n  /* Instead use this non-standard one: */\n  word-break: break-word;\n  display: block;\n}\n\n.user-title, .user-org {\n  color: #909092;\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-gb, .user-moderator {\n  color: #f2b130;\n  font-size: 12px;\n}\n\n.attendees {\n  margin-top: 1em;\n}\n.attendees hr {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.attendees .user-list {\n  padding: 5px;\n  display: block;\n  position: relative;\n}\n.attendees .user-list .user-icons {\n  margin: 0.5em;\n  position: absolute;\n  top: 0;\n  right: 0;\n  color: #606060;\n}\n.attendees .user-list .user-icons ul li {\n  list-style-type: none;\n}\n\n.biz-card-div {\n  cursor: pointer;\n  margin-top: 2px;\n  padding: 5px;\n  text-align: center;\n  background-color: #4330ff;\n  border: 1px solid #4330ff;\n  color: white;\n  width: 100%;\n}\n\n.biz-card-link:hover {\n  color: white;\n  cursor: pointer;\n}\n.biz-card-link:hover:hover {\n  text-decoration: none;\n  color: white;\n}\n\n.user-filter-div {\n  margin-top: 0px;\n  background-color: #002869;\n}\n\n/*user-list*/\n.user-list-link {\n  color: black;\n}\n\n.user-list-link:hover {\n  color: black;\n  background: #f2f2f2;\n}\n\n.user-list.hover:hover {\n  background: #f2f2f2;\n}\n\n.nohover {\n  cursor: default;\n}\n\n.user-list .user-info {\n  display: inline-block;\n  width: 85%;\n  padding: 5px 0 0 10px;\n}\n\n/*user-page*/\n.user-profile .user-list-link:hover {\n  background: none;\n}\n.user-profile .user-list:hover {\n  background: none;\n}\n.user-profile .user-list {\n  margin-top: 1em;\n}\n.user-profile .user-list .user-icons {\n  margin: 0.5em;\n  float: right;\n}\n.user-profile .user-list .user-icons ul li {\n  list-style-type: none;\n}\n.user-profile .user-list:hover {\n  cursor: default;\n}\n.user-profile .blue-header {\n  color: #4330ff;\n}\n.user-profile .user-actions .disabled-send {\n  color: #909092;\n}\n.user-profile .user-actions {\n  padding: 1em 0 1em 0;\n}\n.user-profile .user-actions button {\n  width: 100%;\n  border-radius: 5px;\n  background-color: #f2f2f2;\n  border: 1px solid #c0c0c0;\n  color: #4330ff;\n  margin-bottom: 0.5em;\n}\n.user-profile .user-actions .active-button {\n  background-color: #4330ff;\n  color: white;\n}\n.user-profile .user-bio .no-bio {\n  color: #909092;\n}\n.user-profile .red a button {\n  color: #ff2e2e;\n}\n\n.fa-stack {\n  width: 100%;\n  height: 100%;\n  line-height: 1.5;\n  font-size: 1rem;\n}\n\n.fa-stack[data-count]:after {\n  position: absolute;\n  right: -1%;\n  top: 1%;\n  content: attr(data-count);\n  font-size: 30%;\n  padding: 0.6em;\n  border-radius: 999px;\n  line-height: 0.75em;\n  color: white;\n  background: rgba(255, 0, 0, 0.85);\n  text-align: center;\n  min-width: 2em;\n  font-weight: bold;\n}\n\n/*my-profile*/\n.my-biz-card {\n  background: #dcdcdc;\n  border: 0.15em solid #000;\n  border-radius: 0.75em;\n  padding: 0.75em;\n}\n\n.form-fine-print {\n  color: #909092;\n}\n\n.display-date {\n  background: gray;\n  color: #fff;\n  padding: 0.2em 0.45em;\n}\n\n.session-link {\n  width: calc(100% - 100px);\n}\n.session-link:hover {\n  text-decoration: none;\n}\n\n.session-icons {\n  margin: 0.5em;\n  position: absolute;\n  right: 0;\n  top: 0;\n  color: #606060;\n}\n.session-icons ul li {\n  list-style-type: none;\n}\n\n.user-profile .button-disabled {\n  color: gray !important;\n}\n.user-profile .session {\n  color: black;\n  border: 0.5px solid #eaeaea;\n  line-height: 10px;\n  text-decoration: none;\n  position: relative;\n}\n.user-profile .session:hover {\n  background: #d4e4e9;\n}\n.user-profile .session-time {\n  background: #909092;\n  color: white;\n  padding: 10px;\n}\n.user-profile .session-reg {\n  text-align: center;\n  width: 90px;\n}\n.user-profile .session-reg .fa {\n  margin-top: 0.1em;\n  font-size: 2.25em;\n}\n.user-profile .session-reg .fa.fa-plus-circle {\n  color: gray;\n}\n.user-profile .session-reg .fa.fa-check-circle {\n  color: #4330ff;\n}\n.user-profile .session-reg .fa.fa-check-circle.yellow {\n  color: #feb52b;\n}\n.user-profile .session-name {\n  padding-top: 10px;\n  color: black;\n  line-height: 1em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* These are technically the same, but use both */\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -ms-word-break: break-all;\n  /* This is the dangerous one in WebKit, as it breaks things wherever */\n  word-break: break-all;\n  /* Instead use this non-standard one: */\n  word-break: break-word;\n  display: block;\n}\n.user-profile .session-room {\n  padding-top: 0px;\n  color: #909092;\n  font-size: 12px;\n}\n.user-profile .track-color {\n  display: inline;\n  padding: 1px;\n  float: left;\n  width: 0.25em;\n  min-height: 4.5em;\n  margin-right: 0.35em;\n}\n.user-profile .session-reg {\n  border: 0.5px solid #eaeaea;\n  background: #f2f2f2;\n  padding-right: 0px !important;\n}\n.user-profile .session-reg p {\n  margin: 5px 0 5px -5px;\n  text-align: center;\n}\n\n.blue {\n  color: #4330ff;\n}\n\n.session-name {\n  padding-top: 10px;\n  color: black;\n}\n\n.session-room {\n  padding-top: 0px;\n  color: #909092;\n  font-size: 12px;\n}\n\n.session.itinerary {\n  padding: 20px;\n}\n.session.itinerary .session-name {\n  color: #909092;\n}\n\n@media only screen and (max-width: 760px) {\n  .session-reg {\n    width: 60px;\n    font-size: 12px;\n  }\n}\n.my-profile-photo {\n  margin-top: 30px;\n  text-align: center;\n}\n.my-profile-photo button {\n  border-radius: 5px;\n  background-color: #f2f2f2;\n  border: 1px solid #c0c0c0;\n  color: #4330ff;\n  margin-bottom: 3px;\n  margin-left: 5px;\n}\n.my-profile-photo input[type=file] {\n  display: none;\n}\n.my-profile-photo .custom-file-upload {\n  border-radius: 5px;\n  background-color: #f2f2f2;\n  border: 1px solid #c0c0c0;\n  color: #4330ff;\n  display: inline-block;\n  padding: 6px 12px;\n  margin-left: 5px;\n  cursor: pointer;\n}\n.my-profile-photo .rounded-circle {\n  max-width: 250px;\n}\n\n.business-card-info {\n  background-color: #f2f2f2;\n  border: 1px solid #404040;\n  color: #404040;\n  border-radius: 5px;\n  padding: 10px;\n}\n.business-card-info .name {\n  font-size: 1.5em;\n  font-weight: bold;\n}\n\n","// Font colors\n$success-color: #38bb15;\n$warning-color: #feb52b;\n$error-color: #ff2e2e;\n$link-color: #428bca;\n\n$blue: #2d7cbf;\n$blue-light-gray: #d4e4e9;\n\n$lightest-gray: #f2f2f2;\n$light-gray: #eaeaea;\n$medium-lightest-gray: #dcdcdc;\n$medium-light-gray: #909092;\n$medium-gray: #c0c0c0;\n$medium-dark-gray: #606060;\n$dark-gray: #404040;\n\n$teal: #32c3b5;\n$gold: #f2b130;\n\n$light-base: #006AC7;\n$light-active: #264A82;\n$success-base: #00A76D;\n\n$eblack: #282829;\n$egrey: #dcddde;\n$evanta-blue: #4330ff;\n$evanta-blue-secondary: #5c4ee5;\n$gartner-blue: #002869;\n$active-slider: #3fe85c;\n$solar: #fa504b;\n$solar-secondary: #fb736f;\n$solar-tertiary: #DE0A01;\n\n\n// Font sizes\n$biggest-header: 36px;\n$big-header: 28px;\n$larger: 20px;\n$large: 16px;\n$medium: 14px;\n$small: 13px;\n$smaller: 12px;\n$tiny: 11px;\n\n// Homepage colors\n// $goldLight: #F9D889;\n// $goldPrimary: #F4B213;\n// $goldDark: #92451C;\n// $greenLight: #CDE3A5;\n// $greenPrimary: #9CC84B;\n// $greenDark: #416428;\n// $mintLight: #95E1DA;\n// $mintPrimary: #2BC4B6;\n// $mintDark: #00566B;\n// $purpleLight: #C6B1D4;\n// $purplePrimary: #8D64AA;\n// $purpleDark: #46295B;\n\n$goldLight: #F9D783;\n$goldPrimary: #92451C;\n$goldDark: #F5B51D;\n$greenLight: #C7E09A;\n$greenPrimary: #416428;\n$greenDark: #A0CA51;\n$mintLight: #8EDFD8;\n$mintPrimary: #02576C;\n$mintDark: #33C7B9;\n$purpleLight: #C3ADD2;\n$purplePrimary: #513465;\n$purpleDark: #9068AD;\n\n\n// virtual portal colors\n$vp-dark-gray: #6D6E71;\n$vp-black: #2C2C2C;\n$vp-bright-red: #FA504B;\n$vp-dark-gray-50op: rgba(109, 110, 113, 0.5)\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
